//
//
//
//

import Products from "@/components/blocks/products/Products";

export default {
  name: "RecentlyViewedProducts",
  components: {
    Products
  },
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    productInfo: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  computed: {
    requestedProducts() {
      return this.$store.getters.getRecentlyViewedProducts.filter(item => item.id !== this.productInfo?.id).map(item => item.configuration_id);
    }
  }
}
